<template>
    <div class="sustainable-component wage-employee-competence-matrix">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-employee-competence-matrix</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="internalModel.JobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
            </div>
            <div class="row">
                <div class="col-12">

                    <table class="tableclass">
                        <tr>
                            <td></td>
                            <td class="py-2" valign="bottom" align="center" v-for="(column, index) in matrix.Columns" :key="index" v-html="column" style="font-size:12px"></td>
                        </tr>
                        <tr v-for="(employee, index) in matrix.Employees" :key="index">
                            <td class="px-2" style="background-color:white;">{{employee.EmployeeName}}</td>
                            <td v-for="(competency, index2) in employee.Competencies" :key="index2">
                                <a href="javascript:void(0)" @click="openComment(competency, employee.EmployeeId)" style="color: #717171">
                                    <span v-if="competency.Val == 1" class="tableclass colorcell" style="background-color: #7BB662">
                                        <span>
                                            <i v-if="competency.Comment != null && competency.Comment != ''" style="position: absolute; margin-left: 4px;" class="mdi mdi-message-outline"></i>
                                        </span>
                                    </span><!--green-->
                                    <span v-if="competency.Val == 2" class="tableclass colorcell" style="background-color: #FFD301">
                                            <span>
                                                <i v-if="competency.Comment != null && competency.Comment != ''" style="position: absolute; margin-left: 4px;" class="mdi mdi-message-outline"></i>
                                            </span>
                                    </span><!--yellow-->
                                    <span v-if="competency.Val == 3" class="tableclass colorcell" style="background-color: #E03C32">
                                               <span>
                                                    <i v-if="competency.Comment != null && competency.Comment != ''" style="position: absolute; margin-left: 4px;" class="mdi mdi-message-outline"></i>
                                                </span>
                                    </span><!--red-->
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td class="px-2" style="background-color:white;">Totalt godkända</td>
                            <td v-for="(competency, index2) in matrix.Competencies" :key="index2">
                                <span class="tableclass colorcell text-center">{{competency.EmployeesWithCompetence}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="px-2" style="background-color:white;">Behov kompetenser</td>
                            <td v-for="(competency, index2) in matrix.Competencies" :key="index2">
                                <span v-show="changeCompetenceNeeds == true" class="tableclass colorcell"><input class="text-center" type="text" style="width:20px;background-color:white;" v-model="competency.CompetenceNeeds" /></span>
                                <span v-show="changeCompetenceNeeds == false && hasCompetenceNeeds(competency)" class="tableclass colorcell text-center">{{competency.CompetenceNeeds}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="px-2" style="background-color:white;">Differens</td>
                            <td v-for="(competency, index2) in matrix.Competencies" :key="index2">
                                <span v-show="hasCompetenceNeeds(competency) && getDiff(competency) == 0" class="tableclass colorcell text-center">{{getDiffStr(competency)}}</span>
                                <span v-show="hasCompetenceNeeds(competency) && getDiff(competency) < 0" class="tableclass colorcell text-center" style="background-color: #E03C32">{{getDiffStr(competency)}}</span>
                                <span v-show="hasCompetenceNeeds(competency) && getDiff(competency) > 0" class="tableclass colorcell text-center" style="background-color: #7BB662">{{getDiffStr(competency)}}</span>
                            </td>
                        </tr>
                    </table>

                    <v-btn v-bind:disabled="disabled" v-if="changeCompetenceNeeds == false" size="default" color="primary" class="btn-primary mt-2" @click="toggleChangeCompetenceNeeds">
                        Ändra kompetensbehov
                    </v-btn>
                    <v-btn v-bind:disabled="disabled" v-if="changeCompetenceNeeds == true" size="default" color="primary" class="btn-primary mt-2" @click="updateCompetenceNeeds">
                        Spara kompetensbehov
                    </v-btn>

                    <table class="tableclass mt-3">
                        <tr>
                            <td class="px-2" style="background-color:white;">Godkänd</td>
                            <td><span class="tableclass colorcell" style="background-color: #7BB662"></span></td>
                        </tr>
                        <tr>
                            <td class="px-2" style="background-color:white;">Nästa steg</td>
                            <td><span class="tableclass colorcell" style="background-color: #FFD301"></span></td>
                        </tr>
                        <tr>
                            <td class="px-2" style="background-color:white;">Utveckling</td>
                            <td><span class="tableclass colorcell" style="background-color: #E03C32"></span></td>
                        </tr>
                    </table>

                </div>
            </div>
            <div class="row mt-4">
                <div class="col">
                    <v-btn size="default" color="primary" class="btn-primary" @click="downloadExcel">
                        Exportera som Excel
                    </v-btn>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
        <ViewCompetenceComment v-bind:disabled="disabled" @updated="reload" ref="viewCompetenceComment"></ViewCompetenceComment>

    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import ViewCompetenceComment from "./update/view-competence-comment.vue"
    
    import { getCurrentInstance, ref } from 'vue'

    const viewCompetenceComment = ref(null);

    export default {
        emits: ['updated'],
        name: 'wage-employee-competence-matrix',
        props: {
            model: Object,
            selectedJobPosition: String,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
            ViewCompetenceComment
        },
        methods: {
            openComment(item, employeeId) {
                this.loading++;
                this.viewCompetenceComment.open(item, employeeId);
                this.loading--;
            },
            hasCompetenceNeeds(competency){
                var val = false;
                if(typeof(competency.CompetenceNeeds) != "undefined" && competency.CompetenceNeeds != null){
                    if(competency.CompetenceNeeds > 0)
                    val = true;
                }
                return val;
            },
            reload() {
                try {
                    this.getCompetenceMatrixFromJobPosition(this.selectedPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
            },
            getDiff(competency) {
                var employeesWithCompetence = 0;
                if(typeof(competency.EmployeesWithCompetence) != "undefined" && competency.EmployeesWithCompetence != null)
                    employeesWithCompetence = competency.EmployeesWithCompetence;

                var competenceNeeds = 0;
                if(typeof(competency.CompetenceNeeds) != "undefined" && competency.CompetenceNeeds != null)
                    competenceNeeds = competency.CompetenceNeeds;

                var diff = employeesWithCompetence - competenceNeeds;
                return diff;
            },
            getDiffStr(competency) {
                var employeesWithCompetence = 0;
                if(typeof(competency.EmployeesWithCompetence) != "undefined" && competency.EmployeesWithCompetence != null)
                    employeesWithCompetence = competency.EmployeesWithCompetence;

                var competenceNeeds = 0;
                if(typeof(competency.CompetenceNeeds) != "undefined" && competency.CompetenceNeeds != null)
                    competenceNeeds = competency.CompetenceNeeds;

                var diff = employeesWithCompetence - competenceNeeds;

                if (diff == 0)
                    return "-";
                if (diff > 0)
                    return "+" + diff;
                return diff;
            },
            getId() {
                return getCurrentInstance().uid;
            },
            toggleChangeCompetenceNeeds() {
                this.changeCompetenceNeeds = !this.changeCompetenceNeeds;
            },
            async getCompetenceMatrixFromJobPosition(jobPositionId) {
                this.loading++;
                try {
                    var competenceMatrix = await WageService.getCompetenceMatrixFromJobPosition(jobPositionId);
                    this.matrix = competenceMatrix;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async updateCompetenceNeeds() {
                this.loading++;
                try {
                    await WageService.updateCompetenceNeeds(this.matrix.Competencies);
                    this.changeCompetenceNeeds = false;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async exportAsExcel() {
                this.newWindow = window.open('/WageSettingsExcel/ExportCompetenceMatrix?jobPositionId=' + this.selectedPosition, '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            async downloadExcel() {
                location.href = '/WageSettingsExcel/ExportCompetenceMatrix?jobPositionId=' + this.selectedPosition;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
               changeCompetenceNeeds: false,
               matrix:{
                   Columns:[],
                   Employees: [],
                   Competencies: [],
               },
               selectedPosition:null,
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedPosition: function (newVal) {
                this.getCompetenceMatrixFromJobPosition(newVal);
                this.$emit('positionSelected', newVal)
            },
        },
        mounted() {
            this.internalModel = this.model;
            this.selectedPosition = this.selectedJobPosition;
            if (this.internalModel.JobPositions.length > 0 && this.selectedJobPosition == null) {
                this.selectedPosition = this.internalModel.JobPositions[0].JobPositionId;
            }
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return { viewCompetenceComment }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tableclass {
        border-collapse: collapse;
    }

    .tableclass table, .tableclass th, .tableclass td {
        border: 1px solid;
        border-color:#ccc;
    }

    .colorcell {
        display: block;
        width: 25px;
        height: 25px;
    }

</style>
